import Home from "./home";
import PrivacyPolicy from "./privacyPolicy";
import TermsOfUse from "./termsOfUse";
const Pages = {
  Home,
  PrivacyPolicy,
  TermsOfUse,
};
export default Pages;
